import { isFinite } from 'lodash';
export const recalculateLetterSpacing = (element, { inheritedFontSize }) => {
    const letterSpacing = parseFloat(element.css('letter-spacing'));
    const fontSizeValue = parseInt(inheritedFontSize, 10);
    if (isFinite(letterSpacing) && isFinite(fontSizeValue)) {
        element.css('letter-spacing', `${fontSizeValue * letterSpacing}px`);
    }
};
//# sourceMappingURL=recalculate-letter-spacing.js.map